module.exports = __webpack_public_path__ + "media/images/pdf-logo-dee2a8f8.png";